module.exports = "## How to edit a photo\r\nFollow these simple 4 step process to edit your photos"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-how-to-header.md
// module id = 1163
// module chunks = 0